import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-form-button',
    templateUrl: './form-button.component.html',
    styleUrls: ['form-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatButton, NgClass]
})
export class FormButtonComponent implements Field, OnInit {

  config: FieldConfig;
  group: FormGroup;

  eventcallbackMethod(event: any) {
    if (this.config && this.config.function) {
      this.config.function(event);
    }
  }

  ngOnInit() {
  }
}
